import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import defaultUserAvatar from 'assets/images/default_avatar.jpg';
import defaultGbsAvatar from 'assets/images/gobuyside.jpg';
import defaultFirmAvatar from 'assets/images/default_firm.jpg';
import defaultJobAvatar from 'assets/images/default_job.jpg';
import { AVATAR_TYPE } from 'constants/avatar-type.js';

import './styles.css';

const Avatar = ({ image, name, type, link, size, controlFunc }) => {
  const img = useMemo(() => {
    let src = image;
    let defaultAvatar = defaultUserAvatar;
    if (AVATAR_TYPE.USER === type) {
      defaultAvatar = defaultUserAvatar;
    } else if (AVATAR_TYPE.GOBUYSIDE === type) {
      defaultAvatar = defaultGbsAvatar;
    } else if (AVATAR_TYPE.FIRM === type) {
      defaultAvatar = defaultFirmAvatar;
    } else if (AVATAR_TYPE.JOB === type) {
      defaultAvatar = defaultJobAvatar;
    } else if (AVATAR_TYPE.DEFAULT === type) {
      defaultAvatar = defaultUserAvatar;
    }
    if (!src) {
      src = defaultAvatar;
    }

    const imageOnError = (event) => {
      event.target.src = defaultAvatar;
    }

    return <img className="avatar__image" src={src} alt={name} onError={imageOnError} />;
  }, [image, type]);

  return link ? (
    <NavLink
      className="avatar"
      to={link}
      title={name}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      onClick={controlFunc || null}
      children={img}
    />
  ) : (
    <div
      className="avatar avatar--without-link"
      onClick={controlFunc}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      children={img}
    />
  );
};

Avatar.defaultProps = {
  type: AVATAR_TYPE.DEFAULT,
};

Avatar.propTypes = {
  size: PropTypes.number,
  link: PropTypes.string,
  controlFunc: PropTypes.func,
  image: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf([
    AVATAR_TYPE.GOBUYSIDE,
    AVATAR_TYPE.USER,
    AVATAR_TYPE.FIRM,
    AVATAR_TYPE.JOB,
    AVATAR_TYPE.DEFAULT,
  ]),
};

export default Avatar;
